<template>
  <v-app class="app">
    <router-view></router-view>
    <v-progress-circular v-if="appStateStore.isProgressOpen" :size="50" indeterminate color="#51A8FE"
      class="center-loading"></v-progress-circular>
    <v-snackbar @click="appStateStore.snackbar.clickable ? click() : null" v-model="appStateStore.snackbar.show" location="bottom end" width="200px" height="80px"
      :timeout="appStateStore.snackbar.timeout"
      :color="appStateStore.snackbar.color" class="snackbar-notice">
      <!-- {{ appStateStore.snackbar.text }} -->
      <div class="snackbar-content">
        <div class="snackbar-header">
          {{ appStateStore.snackbar.title }}
        </div>

        <div class="snackbar-body">
          {{ appStateStore.snackbar.text }}
        </div>
      </div>
    </v-snackbar>
    <!-- <MessageBoxDialog :msg="dlgMsg" :caption="dlgCaption" btnType="ExtendClose" iconType="error" @ok="closeMSGDlg"
      @cancel="clickMSGDlgCancelBtn">
    </MessageBoxDialog> -->
  </v-app>
</template>

<script setup>
import { useAppStateStore } from './stores/appState';
import { useRoute, useRouter } from 'vue-router';
import './assets/styles/baseStyle.css';   // 기본 스타일시트
import { watch, computed, provide, onBeforeUnmount, onMounted} from 'vue';
import { useI18n } from 'vue-i18n'
import { openInNewTab, useMsgDlg } from './utils/utils';
import MessageBoxDialog from './components/MessageBoxDialog.vue';
import { useUserStateStore } from './stores/userState';

const { t } = useI18n();
const userState = useUserStateStore();
const router = useRouter();
const { locale } = useI18n()
const appStateStore = useAppStateStore();
const { dlgMsg, dlgCaption, showMsgDialog, init, closeMSGDlg } = useMsgDlg();

const showMsgDlg = computed({
  get: () => userState.showSessionWarning,
  set: (v) => {
    userState.showSessionWarning = v;
  }
});

provide("showMsgDlg", showMsgDlg);
init(showMsgDlg);

const click = () => {
  appStateStore.closeSnackbar();
  openInNewTab(router.resolve('/user/notifications'));
}

const clickMSGDlgCancelBtn = () => {
  userState.showSessionWarning = false;
  showMsgDlg.value = false;
}

const extendSessionOnActivity = () => {
  if (!userState.isAuthenticated) return;
  if (userState.sessionRemainingMs > 25 * 60 * 1000) return;

  userState.extendSession(30);
};

onMounted(() => {
  window.addEventListener('pointerdown', extendSessionOnActivity, {
    capture: true,
    passive: true,
  });
});

onBeforeUnmount(() => {
  window.removeEventListener('pointerdown', extendSessionOnActivity, {
    capture: true,
  });
});

watch(locale, (newLocale) => {
  document.body.classList.remove('lang-ko', 'lang-en')
  if (newLocale === 'ko') document.body.classList.add('lang-ko')
  else document.body.classList.add('lang-en')
}, { immediate: true });

// watch(showMsgDlg, (val) => {
//   if (val === true) {
//     showMsgDialog(
//       t('sessionExpireWarning'),
//       t('sessionExpireTitle'),
//       () => {
//         // ✅ Yes(연장) 콜백(예: OK가 Yes 의미라면)
//         userState.extendSession(30);
//         userState.showSessionWarning = false;
//       }
//     );
//   }
// });
</script>

<style>
/* ✅ 브라우저가 전체 스크롤을 담당하도록 설정 */
body {
  -ms-overflow-style: auto;
}

body::-webkit-scrollbar {
  display: none;
}

/* 클릭 가능 */
.snackbar-notice {
  cursor: pointer;
}

/* 전체 레이아웃 */
.snackbar-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
  white-space: pre-line;
  /* \n 줄바꿈 허용 */
}

/* 헤더 */
.snackbar-header {
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.2px;
  opacity: 0.9;
}

/* 본문 */
.snackbar-body {
  font-size: 12px;
  line-height: 1.4;
  opacity: 0.85;
}

/* hover 효과 (중요) */
.snackbar-notice:hover {
  filter: brightness(1.1);
}
</style>
